import React, { useEffect, useState } from 'react';
import { apiRequest } from '../utils/api';
import '../styles/InventoryAdjustmentList.css'; 

const InventoryAdjustmentList = ({ inventoryId }) => {
  const [adjustments, setAdjustments] = useState([]);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrev, setHasPrev] = useState(false);

  const fetchAdjustments = async (inventoryId, page = 1) => {
    try {
      const res = await apiRequest(`inventory/inventory_adjustments/?inventory_id=${inventoryId}&page=${page}&page_size=5`);
      setAdjustments(res.results || []);
      setHasNext(!!res.next);
      setHasPrev(!!res.previous);
    } catch (err) {
      console.error("在庫履歴取得失敗:", err);
    }
  };

  useEffect(() => {
    if (inventoryId) fetchAdjustments(inventoryId, page);
  }, [inventoryId, page]);

  return (
    <div className="InventoryAdjustmentList__container">
      <div className="InventoryAdjustmentList__title">在庫履歴（最新順）</div>
      <ul className="InventoryAdjustmentList__list">
        {adjustments.map((adj) => (
          <li key={adj.id} className="InventoryAdjustmentList__item">
            <strong>{adj.date?.slice(0, 16).replace('T', ' ')}</strong>：
            {adj.quantity_change > 0 ? '+' : ''}{adj.quantity_change}（{adj.reason}）
          </li>
        ))}
      </ul>
      <div className="InventoryAdjustmentList__pagination">
        <button disabled={!hasPrev} onClick={() => setPage(p => Math.max(p - 1, 1))}>前</button>
        <span>Page {page}</span>
        <button disabled={!hasNext} onClick={() => setPage(p => p + 1)}>次</button>
      </div>
    </div>
  );
};

export default InventoryAdjustmentList;